import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { ModalScreens } from 'components/Navigation/types';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import { filterArrayEmpty, formatCurrency } from 'lib/riskbase';
import { theme } from 'lib/theme';
import { upperFirst } from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  NAVIGATE_MODAL,
  doSetupBillingAdminDeleteProduct,
} from 'store/actions';
import {
  selectRemoteCustomer,
  selectBillingProduct,
  selectRemoteOrganisationId,
} from 'store/remote/selectors';
import { Months } from 'types/types';

type Props = {
  productId: string;
};

export const BillingProductCard: React.FC<Props> = ({ productId }) => {
  const dispatch = useDispatch();

  const product = useSelector((state) =>
    selectBillingProduct(state, productId),
  );
  const organisationId = useSelector(selectRemoteOrganisationId);
  const invoiceToCustomer = useSelector((state) =>
    selectRemoteCustomer(state, product?.invoiceToOrganisationId || '-1'),
  );

  if (!product) {
    return null;
  }

  return (
    <CardRow
      label={product.name}
      label2={[
        upperFirst(product.account) +
          (product.invoiceCode !== 'default'
            ? ` (${product.invoiceCode})`
            : ''),
        product.months.length === 12
          ? 'Every month'
          : `${Months.filter((m) => product.months.includes(m.name))
              .map((m) => m.nameShort)
              .join(', ')}`,
        product.invoiceToOrganisationId === organisationId
          ? null
          : invoiceToCustomer?.name || null,
      ]
        .filter(filterArrayEmpty)
        .join(' • ')}
      onPress={() =>
        dispatch(
          NAVIGATE_MODAL({
            screen: ModalScreens.SettingsBillingProduct,
            params: { productId: product.id },
          }),
        )
      }
      menuOptions={[
        {
          text: 'Delete Product',
          icon: ICONS.TrashCanLight,
          destructive: true,
          onPress: () =>
            dispatch(doSetupBillingAdminDeleteProduct({ id: productId })),
        },
      ]}
    >
      <Txt
        style={{
          textAlign: 'right',
          color: theme.colors.fieldValueText,
        }}
      >
        {formatCurrency(product.cost)}
      </Txt>
    </CardRow>
  );
};
